module.exports = __webpack_public_path__ + "static/media/tribe26.3ec28511.png";